export const errorWarnType = "errorWarn";
